import AppData from './appData';
import CommonService from './commonService';
let operator = JSON.parse(localStorage.getItem('op'));
const ApiUrls = {
	metaData: () => {
		return AppData.BASE_URL + 'api/masters.json?';
	},
	stageDetails: () => {
		return AppData.BASE_URL + 'api/stage_details';
	},

	uniqueCities: operator => {
		return (
			AppData.BASE_URL +
			`api/${operator ? `operator_uniq_cities?travel_id=${operator}` : 'uniq_cities'}`
		);
	},

	serviceList: (originId, destId, journeyDate, isRoundTrip, isReturn, retryCount) => {
		return (
			AppData.BASE_URL +
			`api/${CommonService.isTrain() ? 'train_schedules' : 'ui_schedules'
			}.json?origin_id=${originId}&destination_id=${destId}&travel_date=${journeyDate}&show_only_available_services=false&show_injourney_services=true&is_round_trip=${isRoundTrip ||
			false}&is_roundtrip_return=${isReturn || false}&retry_count=${retryCount}`
		);
	},

	serviceListV2: (
		originId,
		destId,
		journeyDate,
		journeyDateReturn,
		retryCount,
		travelId,
		ismot,
	) => {
		return (
			AppData.BASE_URL +
			`api/v2/op_scheduled_services?origin_id=${originId}&destination_id=${destId}&travel_date=${journeyDate}&show_only_available_services=false&show_injourney_services=true&r_travel_date=${journeyDateReturn}&retry_count=${retryCount}&travel_ids=${travelId}&is_mot=${ismot}`
			// `api/v2/scheduled_services?origin_id=${originId}&destination_id=${destId}&travel_date=${journeyDate}&show_only_available_services=false&show_injourney_services=true&r_travel_date=${journeyDateReturn}&retry_count=${retryCount}`
		);
	},



	serviceListV3: (
		originId,
		destId,
		journeyDate,
		journeyDateReturn,
		retryCount,
		travelId,
		ismot,
	) => {
		return (
			AppData.BASE_URL +
			`api/v3/op_scheduled_services?origin_id=${originId}&destination_id=${destId}&travel_date=${journeyDate}&show_only_available_services=false&show_injourney_services=true&r_travel_date=${journeyDateReturn}&retry_count=${retryCount}&travel_ids=${travelId}&is_mot=${ismot}`
			// `api/v2/scheduled_services?origin_id=${originId}&destination_id=${destId}&travel_date=${journeyDate}&show_only_available_services=false&show_injourney_services=true&r_travel_date=${journeyDateReturn}&retry_count=${retryCount}`
		);
	},

	trainList: (originId, destId, journeyDate) => {
		return (
			AppData.BASE_URL +
			`/api/ui_schedules.json?origin_id=1841&destination_id=1986&travel_date=2020-04-10&show_only_available_services=false&show_injourney_services=true`
		);
	},

	officeDetails: () => {
		return AppData.BASE_URL + `api/office_details`;
	},
	//   trainList: (originId, destId, journeyDate) => {
	//     return (
	//       AppData.BASE_URL +
	//       `api/ui_schedules.json?origin_id=${originId}&destination_id=${destId}&travel_date=${journeyDate}&show_only_available_services=false&show_injourney_services=true`
	//     );
	//   },
	serviceDetails: (scheduleId, isRoundTrip, isReturn) => {
		return (
			AppData.BASE_URL +
			`api/ui_schedule.json?schedule_id=${scheduleId}&is_round_trip=${isRoundTrip ||
			false}&is_roundtrip_return=${isReturn || false}`
		);
	},
	serviceDetailsV2: (scheduleId, is_mot) => {
		return AppData.BASE_URL + `api/v2/scheduled_services/${scheduleId}?is_mot=${is_mot}`;
	},
	serviceDetailsV3: (scheduleId, is_mot, multiStageServiceName) => {
		let url = AppData.BASE_URL + `api/v3/op_scheduled_services/${scheduleId}?is_mot=${is_mot}`;
		if (multiStageServiceName) {
						url += `&multi_stage_service_name=${multiStageServiceName}`;
		}
		
		return url;
},

	bookTicket: isRoundTrip => {
		return (
			AppData.BASE_URL +
			(!isRoundTrip
				? 'api/tentative_booking.json?is_mobile_app=true'
				: 'api/round_trip.json?is_mobile_app=true')
		);
	},
	bookTicketV2: () => {
		return AppData.BASE_URL + 'api/v2/bus_bookings?is_mobile_app=true';
	},
	promoCode: () => {
		return AppData.BASE_URL + 'api/apply_promo_code.json?is_mobile_app=true';
	},
	applyCorporateDiscount: () => {
		return AppData.BASE_URL + 'api_corporate_discounts/apply_corporate_discount';
	},

	applyInstantDiscount: () => {
		return AppData.BASE_URL + 'api_instant_discounts/apply_instant_discount';
	},
	ticketDetails: (pnrNumber, path = null) => {
		return (
			AppData.BASE_URL +
			'api/ticket_details.json?is_mobile_app=true&pnr_number=' +
			pnrNumber +
			(path ? '&' + path : '')
		);
	},

	ticketDetailsV3: () => {
		return AppData.BASE_URL + 'api/v3/api/ticket_details.json';
	},

	ticketDetailsWithPath: (path = null) => {
		return (
			AppData.BASE_URL + 'api/ticket_details.json?is_mobile_app=true&' + path + '&do_cancel=true'
		);
	},

	ticketDetailsAT: (path = null) => {
		return AppData.AT_URL + path;
	},

	ticketCancelDetailsAT: (path = null) => {
		return AppData.AT_URL + path;
	},

	kuposTicketDetails: (id, cat_type) => {
		return AppData.BASE_URL + `api/v1/ticketDetails/${cat_type}`;
	},

	kuposGoTicketDetails: (id, cat_type) => {
		return AppData.BASE_URL + `api/kupos_ticket_details?id=${id}&cat_type=${cat_type}`;
	},

	kuposTicketDetailsAt: pnrNumber => {
		return AppData.AT_URL + `api/v1/ticketDetails/${pnrNumber}`;
	},

	kuposTicketDetailsAtV2: pnrNumber => {
		return AppData.AT_URL + `api/v2/ticketDetails/${pnrNumber}`;
	},

	cancelTicket: path => {
		return AppData.BASE_URL + 'api/cancel_ticket.json?' + path;
	},
	cancelTicketV3: () => {
		return AppData.BASE_URL + 'api/v3/api/cancel_ticket';
	},
	cancelTicketAt: path => {
		return AppData.AT_URL + 'api/v1/cancel';
	},
	cancelTicketAtV2: path => {
		return AppData.AT_URL + 'api/v2/cancel';
	},
	login: () => {
		return AppData.BASE_URL + 'api/customer/login?';
	},
	register: () => {
		return AppData.BASE_URL + 'api/customer/register?';
	},
	accountConfirmation: token => {
		return AppData.BASE_URL + 'api/customer/confirm_account?confirmation_token=' + token;
	},
	resetPassword: () => {
		return AppData.BASE_URL + 'api/customer/request_password?';
	},
	resetNewPassword: () => {
		return AppData.BASE_URL + 'api/customer/change_password';
	},
	generateOtp: () => {
		return AppData.BASE_URL + 'api/generate_sms_code';
	},
	validateOtp: () => {
		return AppData.BASE_URL + 'api/validate_sms_code';
	},

	subscribe: () => {
		return AppData.BASE_URL + 'api/do_subscribe';
	},

	updateProfile: () => {
		return AppData.BASE_URL + 'api/customer/update_profile?';
	},
	profile: () => {
		return AppData.BASE_URL + 'api/customer/profile?';
	},
	myTrips: operator_id => {
		return AppData.BASE_URL + 'api/my_tickets?page=1&per=10&operator_id=' + operator_id;
	},
	poolTrips: () => {
		return AppData.CARPOOL_URL + 'api-customer/orders?noenc=true';
	},

	kuposGoTrips: () => {
		return AppData.BASE_URL + '/api/my_tickets?page=1&per=10&cat_type=kuposgo';
	},

	atTrips: userId => {
		return AppData.AT_URL + 'api/v1/myTrips/' + userId;
	},

	trainTrips: () => {
		return AppData.BASE_URL + '/api/my_tickets?page=1&per=10&cat_type=train';
	},

	myTransactions: (monthYear, operator_id) => {
		return (
			AppData.BASE_URL +
			'api/customer/wallets/histories?month_str=' +
			monthYear +
			'&operator_id=' +
			operator_id
		);
	},
	myVirtualMoney: monthYear => {
		return (
			AppData.BASE_URL +
			'api/customer/wallets/vw_histories?' +
			(monthYear && '&month_str=' + monthYear)
		);
	},
	walletRecharge: () => {
		return AppData.BASE_URL + '/api/wallet_recharge_request';
	},
	rechargeLocations: (lat, lng) => {
		return AppData.BASE_URL + '/api/recharge_locations?latitude=' + lat + '&longitude=' + lng;
	},
	siteMap: () => {
		return AppData.BASE_URL + 'api/site_map';
	},
	customerInfo: (rut, operator_id) => {
		return AppData.BASE_URL + '/api/customer_info?recipient_rut_no=' + rut + operator_id;
	},
	favourites: () => {
		return AppData.BASE_URL + '/api/favourites';
	},
	transferMoney: () => {
		return AppData.BASE_URL + 'api/transfer_money';
	},
	qrImage: () => {
		return AppData.BASE_URL + 'api/qrcode/qr_image_data';
	},
	addBipCard: () => {
		return AppData.BIP_URL + 'api/v1/myCard';
	},
	airportTransferRoutes: ({ lat, lng, fromToAirport, utcTime, seats, currentUTC }) => {
		return (
			AppData.AT_URL +
			`api/v1/service_price_polygon/${lat}/${lng}/${fromToAirport}/${utcTime}/${seats}/${currentUTC}`
		);
	},
	airportTransferRoutesV2: ({
		originLat,
		originLng,
		utcTime,
		destLat,
		destLng,
		utcReturn,
		seats,
		currentUTC,
	}) => {
		return (
			AppData.BASE_URL_V2 +
			`service_inventory/${originLat}/${originLng}/${utcTime}/${destLat}/${destLng}/${utcReturn}/${seats}/${currentUTC}`
		);
	},
	airportTransferRoutesV3: ({
		originLat,
		originLng,
		originLocId,
		utcTime,
		destLat,
		destLng,
		destLocId,
		utcReturn,
		seats,
		currentUTC,
		trfrType,
	}) => {
		return (
			AppData.BASE_URL_V3 +
			`service_inventory/${originLat}/${originLng}/${originLocId}/${utcTime}/${destLat}/${destLng}/${destLocId}/${utcReturn}/${seats}/${currentUTC}/${trfrType}`
		);
	},
	airportTransferBook: () => {
		return AppData.AT_URL + `api/v1/booking`;
	},
	airportTransferBookV2: () => {
		return AppData.AT_URL + `api/v2/booking`;
	},
	kuposGoPostTripDetails: () => {
		return AppData.BASE_URL + `api/special_trip_details`;
		// return `https://pbstage.kupas.cl/api/special_trip_details`;
	},
	googleLogout: googleAccessToken => {
		return 'https://accounts.google.com/o/oauth2/revoke?token=' + googleAccessToken;
	},
	getPassengerInfo: ({ cardType, idCardNumber }) => {
		return (
			AppData.BASE_URL +
			`api/passenger_info?id_card_type=${cardType}&id_card_number=${idCardNumber}`
		);
	},
	operatorPay: () => {
		return AppData.BASE_URL + 'api/customer/operator_pay_config?';
	},

	// CUPONERA
	cuponeraSeats: (origin, destination, travelId) => {
		return (
			AppData.BASE_URL +
			`api/services/get_zone_creation_details.json?origin_id=${origin}&destination_id=${destination}&api_travel_id=${travelId}`
		);
	},
	bookCuponera: () => {
		return AppData.BASE_URL + `api/services/create_zone_mot_coupon`;
	},
	//

	uniqueCitiesTheme11: () => {
		let operator = JSON.parse(localStorage.getItem('op'));
		return AppData.BASE_URL + `airport/${operator.operator_name}/api/cities`;
	},
	getTariffTheme11: ({ originId, destinationId, noOfPassengers }) => {
		return (
			AppData.BASE_URL +
			`airport/${operator.operator_name}/api/${originId}/${destinationId}/${noOfPassengers}/tariffs`
		);
	},
	bookTicketTheme11: () => {
		return AppData.BASE_URL + `airport/${operator.operator_name}/api/booking`;
	},
	contactTheme11: () => {
		return AppData.BASE_URL + `api/opsite_contact_info`;
	},

	specialServicesTravelTur: () => {
		return AppData.BASE_URL + "/api/special_service_request"
	}
};
export default ApiUrls;



// WEBPACK FOOTER //
// ./src/services/apiUrls.js